export default "__VITE_ASSET__CA2uA_T6__"